// This version of mui-datatables merges plain label objects into shared defaults.
// A class instance makes it replace the labels, keeping each table independent.
export default class ReservationTableLabels {
  constructor(noMatch) {
    this.body = { noMatch, toolTip: 'Sort' }
    this.pagination = {
      next: 'Faqja tjetër',
      previous: 'Faqja e mëparshme',
      rowsPerPage: 'Rreshta për faqe:',
      displayRows: 'nga'
    }
    this.toolbar = {
      search: 'Search',
      downloadCsv: 'Download CSV',
      print: 'Print',
      viewColumns: 'View Columns',
      filterTable: 'Filter Table'
    }
    this.filter = { all: 'All', title: 'FILTERS', reset: 'RESET' }
    this.viewColumns = { title: 'Show Columns', titleAria: 'Show/Hide Table Columns' }
    this.selectedRows = { text: 'row(s) selected', delete: 'Delete', deleteAria: 'Delete Selected Rows' }
  }
}
